export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([" номер "])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Имя"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отмена"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сохранить"])}
}